// ui/Button is not use because it adds flex directives that does not work well with new lines inside the button
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "AddSectionButton-root_1KO4o"
};
const AddSectionButton = ({
  children,
  className,
  ...props
}) => /*#__PURE__*/_jsx(Base, {
  ...props,
  tagName: "button",
  className: clsx(className, styles.root),
  paddingX: "small",
  paddingY: "xsmall",
  color: "green",
  backgroundColor: "transparent",
  interactive: true,
  children: children
});
export default AddSectionButton;